import { IconChevronRight16, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { ENewReviewFlow } from '../../../types/newReview';
import * as styles from '../../../containers/DailyrentNewReview/ReviewFlowContainer/styles.css';

interface IProps {
  type: ENewReviewFlow;
  title: string;
  description: string;
  onClick(type: ENewReviewFlow): void;
}

export function FlowRow({ type, title, description, onClick }: IProps) {
  const handleClick = React.useCallback(() => {
    onClick(type);
  }, [onClick, type]);

  return (
    <div className={styles['row']} onClick={handleClick}>
      <div className={styles['text-box']}>
        <div className={styles['row-title']}>
          <UIText1>{title}</UIText1>
        </div>
        <div className={styles['row-description']}>
          <UIText2>{description}</UIText2>
        </div>
      </div>
      <div className={styles['row-icon']}>
        <IconChevronRight16 />
      </div>
    </div>
  );
}
